import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { initialFiledFunc, } from "../../components/Common/validationFunction";
import { C_Button } from "../../components/Common/CommonButton";
import { C_DatePicker, C_Select } from "../../CustomValidateForm";
import * as _cfunc from "../../components/Common/CommonFunction";
import { mode, } from "../../routes/index"
import { MetaTags } from "react-meta-tags";
import { getBaseUnit_ForDropDown, goButtonPartyItemAddPage, getpdfReportdata, getpdfReportdataSuccess, goButtonPartyItemAddPageSuccess } from "../../store/actions";
import { customAlert } from "../../CustomAlert/ConfirmDialog";
import * as report from '../ReportIndex'
import { ItemRegister_API, StockProcessing_API } from "../../helpers/backend_helper";
import C_Report from "../../components/Common/C_Report";
import { alertMessages } from "../../components/Common/CommonErrorMsg/alertMsg";
import { ExcelReportComponent } from "../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";

const ItemRegisterReport = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();

    const fileds = {
        FromDate: currentDate_ymd,
        ToDate: currentDate_ymd,
        Item: "",
        Unit: { value: 1, label: 'No' },
    }

    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [userPageAccessState, setUserAccState] = useState('');
    const [excelLoading, setExcelLoading] = useState(false);

    const [stockProcessLoading, setStockProcessLoading] = useState(false);
    const [clickedBtn, setClickedBtn] = useState("");

    const reducers = useSelector(

        (state) => ({
            pdfdata: state.PdfReportReducers.pdfdata,
            ItemList: state.PartyItemsReducer.partyItem,
            BaseUnit: state.ItemMastersReducer.BaseUnit,
            goBtnLoading: state.PdfReportReducers.goBtnLoading,
            supplier: state.CommonAPI_Reducer.vendorSupplierCustomer,
            userAccess: state.Login.RoleAccessUpdateData,
            SSDD_List: state.CommonAPI_Reducer.SSDD_List,
            CustomerLoading: state.CommonAPI_Reducer.vendorSupplierCustomerLoading,
            pageField: state.CommonPageFieldReducer.pageFieldList
        })
    );

    const { userAccess, pdfdata, CustomerLoading, ItemList, BaseUnit } = reducers;

    const values = { ...state.values }

    // Featch Modules List data  First Rendering
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue);

    const { commonPartyDropSelect } = useSelector((state) => state.CommonPartyDropdownReducer);

    // Common Party select Dropdown useEffect
    useEffect(() => {
        _cfunc.saveLogoToLocalStorage()
        if (commonPartyDropSelect.value > 0) {
            partySelectButtonHandler();
        } else {
            partySelectOnChangeHandler();
        }
    }, [commonPartyDropSelect]);

    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;
        if (hasShowModal) {
            locationPath = props.masterPath;
        };
        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })
        if (userAcc) {
            setUserAccState(userAcc)
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    useEffect(() => {
        dispatch(getBaseUnit_ForDropDown());
        if (!(commonPartyDropSelect.value === 0)) {
            const jsonBody = JSON.stringify({ ..._cfunc.loginJsonBody(), "PartyID": commonPartyDropSelect.value });
            dispatch(goButtonPartyItemAddPage({ jsonBody }));
        };

    }, [])

    useEffect(() => {
        if ((pdfdata.Status === true) && (pdfdata.StatusCode === 204)) {
            dispatch(getpdfReportdataSuccess({ Status: false }))
            customAlert({
                Type: 3,
                Message: pdfdata.Message,
            })
            return
        }
    }, [pdfdata])

    const ItemOptions = ItemList.map((i) => ({
        value: i.Item,
        label: i.ItemName,
    }))

    const BaseUnit_DropdownOptions = [

        ...BaseUnit
            .filter(index =>
                index.Name === "No" ||
                index.Name === "Kg" ||
                index.Name === "Box"
            )
            .map(data => ({
                value: data.id,
                label: data.Name
            })),
        { value: 0, label: "BaseUnit" }
    ];



    const onselecthandel = (e) => {
        setState((i) => {
            const a = { ...i }
            a.values.Item = e;
            a.hasValid.Item.valid = true
            return a
        })
    }

    const onUnitselecthandel = (e) => {
        setState((i) => {
            const a = { ...i }
            a.values.Unit = e;
            a.hasValid.Unit.valid = true
            return a
        })
    }

    function goButtonHandler() {

        if (commonPartyDropSelect.value === 0) {
            customAlert({ Type: 3, Message: alertMessages.commonPartySelectionIsRequired });
            return;
        };

        const jsonBody = JSON.stringify({
            "FromDate": values.FromDate,
            "ToDate": values.ToDate,
            "Item": values.Item.value,
            "Unit": values.Unit.value,
            "Party": commonPartyDropSelect.value
        });

        let config = {
            ReportType: report.ItemRegister, jsonBody, ItemName: values.Item.label, FromDate: values.FromDate, ToDate: values.ToDate, Unit: values.Unit
        }

        if (values.Item === "") {
            customAlert({
                Type: 3,
                Message: alertMessages.itemNameIsRequired,
            })
            return
        } else {
            dispatch(getpdfReportdata(ItemRegister_API, config))
        }
    }

    async function excelHandler() {

        if (commonPartyDropSelect.value === 0) {
            customAlert({ Type: 3, Message: alertMessages.commonPartySelectionIsRequired });
            return;
        }

        if (values.Item === "") {
            customAlert({
                Type: 3,
                Message: alertMessages.itemNameIsRequired,
            });
            return;
        }
        setExcelLoading(true);

        try {
            const jsonBody = JSON.stringify({
                FromDate: values.FromDate,
                ToDate: values.ToDate,
                Item: values.Item.value,
                Unit: values.Unit.value,
                Party: commonPartyDropSelect.value
            });

            const response = await ItemRegister_API({ jsonBody });

            if (response.Status === true) {

                let balance = 0;
                let totalIn = 0;
                let totalOut = 0;

                const data = [];

                //  Opening Balance
                const summary = response.Data.find(x => x.OpeningBalance !== undefined);
                balance = summary?.OpeningBalance || 0;

                data.push({
                    Date: "",
                    Name: "   Opening Balance",
                    "Document No": "",
                    "Document Type": "",
                    "In Qty": "",
                    "Out Qty": "",
                    Balance: balance
                });

                //  MAIN LOOP 
                response.Data
                    .filter(row => row.TransactionDate)
                    .forEach(row => {



                        let inQty = "";
                        let outQty = "";
                        let docType = "";

                        if (row.Sequence === 1) {
                            inQty = Number(row.Quantity);
                            balance += inQty;
                            totalIn += inQty;
                            docType = "GRN";
                        }
                        else if (row.Sequence === 2) {
                            inQty = Number(row.Quantity);
                            balance += inQty;
                            totalIn += inQty;
                            docType = "SalesReturn";
                        }
                        else if (row.Sequence === 3) {
                            totalIn = 0;
                            totalOut = 0;

                            inQty = Number(row.Quantity);
                            balance = inQty;
                            totalIn += inQty;   // 
                            docType = "Stock";
                        }
                        else if (row.Sequence === 4) {
                            outQty = Number(row.Quantity);
                            balance -= outQty;
                            totalOut += outQty;
                            docType = "Sale";
                        }
                        else if (row.Sequence === 5) {
                            outQty = Number(row.Quantity);
                            balance -= outQty;
                            totalOut += outQty;
                            docType = "Purchase Return";
                        }
                        else if (row.Sequence === 13) {
                            outQty = Number(row.Quantity);
                            balance -= outQty;
                            totalOut += outQty;
                            docType = "Wastage";
                        }
                        else if (row.Sequence === 14) {
                            outQty = Number(row.Quantity);
                            balance -= outQty;
                            totalOut += outQty;
                            docType = "Tolerance";
                        }
                        data.push({
                            Date: `${row.TransactionDate} (${new Date(row.CreatedOn).toLocaleTimeString()})`,
                            Name: row.Name,
                            "Document No": row.TransactionNumber,
                            "Document Type": docType,
                            "In Qty": inQty,
                            "Out Qty": outQty,
                            Balance: Number(balance.toFixed(2))
                        });
                    });

                //  GRAND TOTAL
                data.push({
                    Date: "",
                    Name: "Grand Total",
                    "Document No": "",
                    "Document Type": "",
                    "In Qty": Number(totalIn.toFixed(2)),
                    "Out Qty": Number(totalOut.toFixed(2)),
                    Balance: ""
                });

                //  Closing Balance
                const closing = summary?.ClosingBalance || balance;

                data.push({
                    Date: "",
                    Name: "Closing Balance",
                    "Document No": "",
                    "Document Type": "",
                    "In Qty": "",
                    "Out Qty": "",
                    Balance: closing
                });

                //  FINAL DOWNLOAD
                ExcelReportComponent({
                    excelTableData: data,
                    excelFileName: "Material Register",

                    ExtraHeader: [
                        `Customer: ${_cfunc.loginUserDetails().PartyName}`,
                        `Material: ${values.Item.label}`,
                        `From Date: ${values.FromDate}     To Date: ${values.ToDate}`
                    ]
                });

            } else {
                customAlert({
                    Type: 4,
                    Message: response.Message || "Something went wrong"
                });
            }

        } catch (error) {
            customAlert({
                Type: 4,
                Message: "Excel download failed"
            });
            console.error(error);
        } finally {
            setExcelLoading(false);
        }
    }

    const executeStockProcess = async () => {

        const today = _cfunc.date_ymd_func();

        const yesterday = _cfunc.date_ymd_func(
            new Date(new Date().setDate(new Date().getDate() - 1))
        );

        return await StockProcessing_API({
            jsonBody: JSON.stringify({
                FromDate: yesterday,
                ToDate: today,
                Party: commonPartyDropSelect.value
            })
        });
    };

    async function handlePrintClick() {

        if (commonPartyDropSelect.value === 0) {
            customAlert({
                Type: 3,
                Message: alertMessages.commonPartySelectionIsRequired
            });
            return;
        }

        if (values.Item === "") {
            customAlert({
                Type: 3,
                Message: alertMessages.itemNameIsRequired
            });
            return;
        }

        try {

            setClickedBtn("print");
            setStockProcessLoading(true);

            const response = await executeStockProcess();

            if (!(response?.Status === true)) {

                customAlert({
                    Type: 4,
                    Message: response?.Message
                });

                return;
            }



            goButtonHandler();

        } catch (error) {

            customAlert({
                Type: 4,
                Message: "Stock Process Failed"
            });

        } finally {

            setStockProcessLoading(false);
        }
    }

    async function handleExcelClick() {

        if (commonPartyDropSelect.value === 0) {
            customAlert({
                Type: 3,
                Message: alertMessages.commonPartySelectionIsRequired
            });
            return;
        }

        if (values.Item === "") {
            customAlert({
                Type: 3,
                Message: alertMessages.itemNameIsRequired
            });
            return;
        }

        try {

            setClickedBtn("excel");
            setStockProcessLoading(true);

            const response = await executeStockProcess();

            if (!(response?.Status === true)) {

                customAlert({
                    Type: 4,
                    Message: response?.Message
                });

                return;
            }


            await excelHandler();

        } catch (error) {

            customAlert({
                Type: 4,
                Message: "Stock Process Failed"
            });

        } finally {

            setStockProcessLoading(false);
        }
    }


    function fromdateOnchange(e, date) {
        setState((i) => {
            const a = { ...i }
            a.values.FromDate = date;
            a.hasValid.FromDate.valid = true
            return a
        })
    }

    function todateOnchange(e, date) {
        setState((i) => {
            const a = { ...i }
            a.values.ToDate = date;
            a.hasValid.ToDate.valid = true
            return a
        })
    }

    function partySelectButtonHandler() {
        const jsonBody = JSON.stringify({ ..._cfunc.loginJsonBody(), "PartyID": commonPartyDropSelect.value });
        dispatch(goButtonPartyItemAddPage({ jsonBody }));
    }

    function partySelectOnChangeHandler() {
        dispatch(getpdfReportdataSuccess({ Status: false }));
        dispatch(goButtonPartyItemAddPageSuccess([]));
        setState((i) => {
            let a = { ...i }
            a.values.Item = ""
            a.hasValid.Item.valid = true;
            return a
        })
    }

    return (
        <React.Fragment>
            <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>
            <div className="page-content">

                <div className="px-2   c_card_filter text-black " >
                    <Row>
                        <Col sm={3} className="">
                            <FormGroup className=" row mt-2  " >
                                <Label className="col-sm-4 p-2"
                                    style={{ width: "83px" }}>FromDate</Label>
                                <Col sm="7">
                                    <C_DatePicker
                                        name='FromDate'
                                        value={values.FromDate}
                                        onChange={fromdateOnchange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>

                        <Col sm={3} className="">
                            <FormGroup className=" row mt-2 " >
                                <Label className="col-sm-4 p-2"
                                    style={{ width: "65px" }}>ToDate</Label>
                                <Col sm="7">
                                    <C_DatePicker
                                        name="ToDate"
                                        value={values.ToDate}
                                        onChange={todateOnchange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>


                        <Col sm={3} className="">
                            <FormGroup className=" row mt-2" >
                                <Label className="col-sm-4 p-2"
                                    style={{ width: "65px", marginRight: "20px" }}>Item</Label>
                                <Col sm="8">
                                    <C_Select
                                        name="Item"
                                        value={values.Item}
                                        isSearchable={true}
                                        isLoading={CustomerLoading}
                                        className="react-dropdown"
                                        classNamePrefix="dropdown"
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 2 })
                                        }}
                                        options={ItemOptions}
                                        onChange={(e) => { onselecthandel(e) }}

                                    />
                                </Col>
                            </FormGroup>
                        </Col>


                        <Col sm={2} >
                            <FormGroup className=" row mt-2" >
                                <Label className="col-sm-4 p-2"
                                    style={{ width: "25px", marginRight: "20px" }}>Unit</Label>
                                <Col sm="7">
                                    <C_Select
                                        name="Unit"
                                        value={values.Unit}
                                        isSearchable={true}
                                        isLoading={CustomerLoading}
                                        className="react-dropdown"
                                        classNamePrefix="dropdown"
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 2 })
                                        }}
                                        options={BaseUnit_DropdownOptions}
                                        onChange={(e) => { onUnitselecthandel(e) }}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>



                        <Col sm={1} className="d-flex justify-content-end">

                            <C_Button
                                type="button"
                                spinnerColor="white"
                                className="btn btn-primary border-1 font-size-12 text-center m-3 mr"
                                onClick={handlePrintClick}
                                disabled={stockProcessLoading}
                                loading={
                                    clickedBtn === "print"
                                        ? (stockProcessLoading || reducers.goBtnLoading)
                                        : reducers.goBtnLoading
                                }
                            >
                                Print
                            </C_Button>

                            <C_Button
                                type="button"
                                spinnerColor="white"
                                onClick={handleExcelClick}
                                className="btn btn-success m-3 mr"
                                disabled={stockProcessLoading}
                                loading={
                                    clickedBtn === "excel"
                                        ? (stockProcessLoading || excelLoading)
                                        : excelLoading
                                }
                            >
                                Excel
                            </C_Button>

                        </Col>
                    </Row>
                </div>


            </div>
            <C_Report />
        </React.Fragment >
    )
}

export default ItemRegisterReport;